import {PriceObject} from 'types';

/**
 * Get the discount price
 * @param {PriceObject} price
 * @param {PriceObject<amount>} sale
 * @return {PriceObject}
 */
export default function getDiscountPrice(
    price: PriceObject,
    sale: PriceObject['amount'],
): PriceObject {
  return {
    currency: price.currency,
    amount: Math.floor(price.amount - sale),
  };
}
